import { initGoftino } from "@/services/external/goftino.service";
// import {initYektanet} from "@/services/external/yektanet.service";
// import {initHotjar} from "@/services/external/hotjar.service";
// import {initMediaAd} from "@/services/external/mediaad.service";
// import {initDezhino} from "@/services/external/dezhino.service";



/**
 * Initializes all external services.
 */
export function initExternalServices(){
    /**
     * Initializes all external services.
     */
    initGoftino();
    // initYektanet();
    // initHotjar();
    // initMediaAd();
    // initDezhino();
}